/**
 * Emit hosts for the `dictation` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type LegacyInlineDictationCompletedEventProps } from '@/models/analytics/features/dictation';

export function trackLegacyInlineDictationCompleted(
  props: LegacyInlineDictationCompletedEventProps
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.LegacyInlineDictationCompleted,
    props,
  });
}
